import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Typography } from 'antd';
import { useMediaQuery } from 'react-responsive';

import CustomModal from '../modal';
import { CloseIcon } from '../icons';

const { Title, Paragraph } = Typography;

const SeagullCoastModal = ({ open, onClose }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  if (isMobile) {
    return (
      <Drawer
        placement="bottom"
        height="80vh"
        closeIcon={(
          <span>
            <CloseIcon onClick={onClose} />
          </span>
        )}
        mask={false}
        open={open}
        onClose={onClose}
        className="seagull-coast-drawer"
        size="large"
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '95%',
          }}
        >
          <div
            style={{
              textAlign: 'center',
              maxWidth: 466,
              margin: '0 auto',
              padding: 0,
            }}
          >
            <Typography.Paragraph
              style={{
                color: 'white',
                fontSize: 14,
                lineHeight: 1.4,
              }}
            >
              The
              <a href="https://glos.org/"> Great Lakes Observing System </a>
              is excited to announce the launch of our new mobile app,
              <a href="https://glos.org/seagull-coast/"> Seagull Coast</a>
              .
            </Typography.Paragraph>
            <Typography.Paragraph
              style={{
                color: 'white',
                fontSize: 14,
                lineHeight: 1.4,
              }}
            >
              Seagull Coast is designed for quick, on-the-go access with personalized
              guidance tailored to how YOU use the lakes. Whether you are planning a day
              at the beach, launching a kayak, taking the boat out, or exploring the
              shoreline, Seagull Coast brings what you love about Seagull into a mobile-first
              experience with environmental conditions, coastal hazard information, and
              safety insights at your fingertips.
            </Typography.Paragraph>
            <Typography.Paragraph
              style={{
                color: 'white',
                fontSize: 14,
                lineHeight: 1.4,
              }}
            >
              Download the app for
              <a href="https://apps.apple.com/us/app/seagull-coast/id6755694594"> iOS </a>
              or
              <a href="https://play.google.com/store/apps/details?id=com.seagullcoast.app"> Android</a>
            </Typography.Paragraph>
            <Typography.Paragraph
              style={{
                color: 'white',
                fontSize: 14,
                lineHeight: 1.4,
              }}
            >
              Your use and feedback are critical to improving the app as it takes to
              the skies. Download it today and
              <a href="mailto:coastsupport@glos.org"> let us know what you think </a>
              !
            </Typography.Paragraph>
            <br />
            <a onClick={onClose}>Close</a>
          </div>
        </div>
      </Drawer>
    );
  }

  return (
    <CustomModal
      open={open}
      onOk={onClose}
      onCancel={onClose}
      footer={null}
      className="announcementModal"
      width={700}
      bodyStyle={{ maxHeight: '65vh', overflowY: 'auto' }}
    >
      <div style={{ padding: 10 }}>
        <Title level={2} style={{ fontSize: 24 }}>
          Seagull Coast
        </Title>
        <Paragraph style={{ fontSize: 16 }}>
          The
          <a href="https://glos.org/"> Great Lakes Observing System </a>
          is excited to announce the launch of our new mobile app,
          <a href="https://glos.org/seagull-coast/"> Seagull Coast</a>
          .
        </Paragraph>
        <Paragraph style={{ fontSize: 16 }}>
          Seagull Coast is designed for quick, on-the-go access with personalized
          guidance tailored to how YOU use the lakes. Whether you are planning a day
          at the beach, launching a kayak, taking the boat out, or exploring the
          shoreline, Seagull Coast brings what you love about Seagull into a mobile-first
          experience with environmental conditions, coastal hazard information, and
          safety insights at your fingertips.
        </Paragraph>
        <Paragraph style={{ fontSize: 16 }}>
          Your use and feedback are critical to improving the app as it takes to
          the skies. Download it today and
          <a href="mailto:coastsupport@glos.org"> let us know what you think </a>
          !
        </Paragraph>
        <Paragraph style={{ fontSize: 16 }}>
          Your use and feedback are critical to improving the app as it takes to the skies. Download it today and let us know what you think!
        </Paragraph>
      </div>
    </CustomModal>
  );
};

SeagullCoastModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

SeagullCoastModal.defaultProps = {
  open: false,
  onClose: () => {},
};

export default SeagullCoastModal;
